import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const Header = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobileMenu = () => setMobileOpen((o) => !o);
  const handleLinkClick = () => setMobileOpen(false);

  return (
    <header className="bg-gradient-to-r from-primary via-primary-dark to-indigo-700 text-white py-3 px-4 shadow-lg sticky top-0 z-10">
      <div className="container mx-auto flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">PolicyPulse</h1>
          <p className="text-xs opacity-90">Danish Parliament Analysis</p>
        </div>
        <div className="flex items-center space-x-4">
          {/* Mobile menu button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded hover:bg-white/10 focus:outline-none"
            aria-label="Toggle navigation"
          >
            {mobileOpen ? (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>

          <div className="hidden md:block">
            <div className="flex space-x-2">
              <Link
                to="/"
                className={`text-white no-underline py-2 px-3 rounded transition hover:bg-white/10 ${
                  location.pathname === '/' ? 'bg-white/20' : ''
                }`}
              >
                Dashboard
              </Link>
              <Link 
                to="/meetings" 
                className={`text-white no-underline py-2 px-3 rounded transition hover:bg-white/10 ${
                  location.pathname === '/meetings' ? 'bg-white/20' : ''
                }`}
              >
                Meetings
              </Link>
              <Link 
                to="/parliament-members" 
                className={`text-white no-underline py-2 px-3 rounded transition hover:bg-white/10 ${
                  location.pathname === '/parliament-members' ? 'bg-white/20' : ''
                }`}
              >
                Members
              </Link>
            </div>
          </div>
          <ThemeToggle />
        </div>
      </div>

      {/* Mobile navigation links */}
      {mobileOpen && (
        <div className="md:hidden mt-2 space-y-1">
          <Link
            to="/"
            onClick={handleLinkClick}
            className={`block text-white no-underline py-2 px-3 rounded transition hover:bg-white/10 ${
              location.pathname === '/' ? 'bg-white/20' : ''
            }`}
          >
            Dashboard
          </Link>
          <Link
            to="/meetings"
            onClick={handleLinkClick}
            className={`block text-white no-underline py-2 px-3 rounded transition hover:bg-white/10 ${
              location.pathname === '/meetings' ? 'bg-white/20' : ''
            }`}
          >
            Meetings
          </Link>
          <Link
            to="/parliament-members"
            onClick={handleLinkClick}
            className={`block text-white no-underline py-2 px-3 rounded transition hover:bg-white/10 ${
              location.pathname === '/parliament-members' ? 'bg-white/20' : ''
            }`}
          >
            Members
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
